"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var moment = require("moment");
var React = require("react");
var react_redux_1 = require("react-redux");
var button_component_1 = require("../../../common/buttons/button_component");
var text_filed_with_fromto_Daterange_1 = require("../../../common/text_filed/text_filed_with_fromto_Daterange");
var auto_routing_helper_1 = require("../control_dashboard/auto_routing_helper");
var react_hot_toast_1 = require("react-hot-toast");
var auto_routing_api_calls_1 = require("../control_dashboard/auto_routing_api_calls");
var react_query_1 = require("react-query");
var api_urls_1 = require("../../../api/api_urls");
require("./new_dashboard_styles.scss");
var pop_up_1 = require("../../../common/modal/pop-up");
var route_path_1 = require("../../../constants/route_path");
var react_router_dom_1 = require("react-router-dom");
var conroldashboardstyles_1 = require("../control_dashboard/list/conroldashboardstyles");
var fe_dashboard_list_1 = require("./fe_dashboard_list");
var multi_selector_1 = require("../../../common/checkbox/multi_selector");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var array_helpers_1 = require("../../../utils/array_helpers");
var leavetracking_apicalls_1 = require("../../field_exicutive/leave_tracking/leavetracking.apicalls");
var NewDashboard = function () {
    var _a, _b, _c, _d, _e, _f;
    var nav = (0, react_router_dom_1.useNavigate)();
    var classes = (0, conroldashboardstyles_1.useStyles)();
    var auto_routing_filtes = (0, react_redux_1.useSelector)(function (state) { return state.FE_creation_reducer.auto_routing_filtes; });
    var labList = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList.labList; });
    var stateList = (0, react_redux_1.useSelector)(function (store) { return store.appConfigList; }).stateList;
    var _g = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList; }), regional_managers = _g.regional_managers, zonal_managers = _g.zonal_managers;
    var _h = React.useState({}), dashboardData = _h[0], setDashboardData = _h[1];
    var _j = React.useState(false), navigationPopup = _j[0], setNavigationPopup = _j[1];
    var _k = React.useState(false), open = _k[0], setOpen = _k[1];
    var _l = React.useState(), selectedLab = _l[0], setSelectedLab = _l[1];
    var _m = React.useState(), classN = _m[0], setClassN = _m[1];
    var _o = React.useState(1), feDashboardFilter = _o[0], setFeDashboardFilter = _o[1];
    var _p = React.useState(((_a = auto_routing_filtes === null || auto_routing_filtes === void 0 ? void 0 : auto_routing_filtes.date_range) === null || _a === void 0 ? void 0 : _a.start_date)
        ? auto_routing_filtes.date_range.start_date
        : new Date().toString()), startDate = _p[0], setStartDate = _p[1];
    var _q = React.useState(((_b = auto_routing_filtes === null || auto_routing_filtes === void 0 ? void 0 : auto_routing_filtes.date_range) === null || _b === void 0 ? void 0 : _b.end_date)
        ? auto_routing_filtes.date_range.end_date
        : new Date().toString()), endDate = _q[0], setEndDate = _q[1];
    var _r = React.useState(false), isDateRangeUpdated = _r[0], setIsDateRangeUpdated = _r[1];
    var companiesList = (0, react_redux_1.useSelector)(function (store) { return store.appConfigList.company_names; });
    var _s = React.useState(), company = _s[0], setCompany = _s[1];
    var _t = React.useState(), zonalManager = _t[0], setZonalManager = _t[1];
    var _u = React.useState(), regionalManager = _u[0], setRegionalManager = _u[1];
    var _v = React.useState(), selectedVendor = _v[0], setSelectedVendor = _v[1];
    var _w = React.useState([]), filterSelectedStates = _w[0], setSelectedFilterStates = _w[1];
    var _x = React.useState([]), citiesData = _x[0], setCitiesData = _x[1];
    var _y = React.useState([]), vendorList = _y[0], setVendorList = _y[1];
    var _z = React.useState([]), filterSelectedCities = _z[0], setSelectedFilterCities = _z[1];
    var _0 = React.useState({}), payload = _0[0], setPayload = _0[1];
    var callBackOnDateRangeSelect = function (dateRangeArray) {
        if (dateRangeArray) {
            setStartDate(moment(dateRangeArray.start).format('YYYY-MM-DD'));
            setEndDate(moment(dateRangeArray.end).format('YYYY-MM-DD'));
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setIsDateRangeUpdated(!isDateRangeUpdated);
    };
    var filterHandler = function () {
        fetchActiveFEStats.refetch();
    };
    var callbackUpdateSelectedStates = function (value) {
        setCitiesData([]);
        setSelectedFilterCities([]);
        setSelectedFilterStates(value);
    };
    var callbackUpdateSelectedCities = function (value) {
        setSelectedFilterCities(value);
    };
    var handleDrawerClose = function () { return setOpen(false); };
    var fetchCities = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stateIdArray, payloadToFetchCities;
        return __generator(this, function (_a) {
            stateIdArray = filterSelectedStates.map(function (state) { return state.id; });
            payloadToFetchCities = {
                state_id: stateIdArray,
            };
            (0, leavetracking_apicalls_1.fetchCitiesList)(payloadToFetchCities)
                .then(function (citiesListResponse) {
                var formattedCitiesList = (0, array_helpers_1.convertLabelAndValueCity)(citiesListResponse.cities);
                setCitiesData(formattedCitiesList);
            })
                .catch(function (e) {
                setCitiesData([]);
            });
            return [2];
        });
    }); };
    var fetchVendorList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, auto_routing_api_calls_1.fetchVendors)()
                .then(function (response) {
                var vendorList = [];
                response === null || response === void 0 ? void 0 : response.data.map(function (data) {
                    vendorList.push({
                        id: String("".concat(data.axapta_code)),
                        label: String("".concat(data.axapta_code, ",").concat(data.name)),
                    });
                });
                setVendorList(vendorList);
            })
                .catch(function (e) {
                setVendorList([]);
            });
            return [2];
        });
    }); };
    var fetchActiveFEStats = (0, react_query_1.useQuery)(['fetchActiveFEStats'], function () { return __awaiter(void 0, void 0, void 0, function () {
        var dateRangeArr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (startDate && endDate) {
                        dateRangeArr = {
                            start_date: moment(startDate).format('YYYY-MM-DD'),
                            end_date: moment(endDate).format('YYYY-MM-DD'),
                        };
                        payload['date_range'] = dateRangeArr;
                    }
                    return [4, (0, auto_routing_api_calls_1.fetchDashboardDetails)(api_urls_1.api_urls.DASHBOARD_ACTIVE_FE_STATS, payload, process.env.APPROVAL_BASEURL)
                            .then(function (res) {
                            setDashboardData(res);
                        })
                            .catch(function (err) {
                            react_hot_toast_1.default.error(err);
                        })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); });
    var navigateToMyReports = function () {
        setNavigationPopup(false);
        nav("/".concat(route_path_1.default.PATHS.reports, "/").concat(route_path_1.default.PATHS.MYREPORTS));
    };
    React.useEffect(function () {
        if (filterSelectedStates.length >= 1) {
            fetchCities();
        }
    }, [filterSelectedStates]);
    React.useEffect(function () {
        fetchVendorList();
    }, []);
    React.useEffect(function () {
        var dashboardPayload = {};
        if (startDate && endDate) {
            var dateRangeArr = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            dashboardPayload['date_range'] = dateRangeArr;
        }
        if (company) {
            dashboardPayload['company_code'] = company.label;
        }
        if (zonalManager) {
            dashboardPayload['zonal_manager_id'] = zonalManager.zonal_manager_id;
        }
        if (regionalManager) {
            dashboardPayload['regional_manager_id'] = regionalManager.regional_manager_id;
        }
        if (selectedVendor) {
            dashboardPayload['vendor_id'] = selectedVendor.id;
        }
        if (filterSelectedCities.length > 0) {
            var states_1 = [];
            var cities_1 = [];
            filterSelectedCities.map(function (selectedCityObj) {
                cities_1.push(selectedCityObj.short_code);
            });
            filterSelectedStates.map(function (selectedStateObj) {
                states_1.push(selectedStateObj.label);
            });
            dashboardPayload['state'] = filterSelectedStates.length >= 30 ? ['ALL'] : states_1;
            dashboardPayload['city'] = filterSelectedCities.length >= 500 ? ['ALL'] : cities_1;
        }
        if ((selectedLab === null || selectedLab === void 0 ? void 0 : selectedLab.length) > 0) {
            var labCode = (0, array_helpers_1.selecteAllOption)(selectedLab, labList);
            dashboardPayload['lab_code'] = labCode;
        }
        setPayload(dashboardPayload);
    }, [startDate, endDate, company, zonalManager, regionalManager, selectedVendor, filterSelectedCities.length > 0, selectedLab]);
    return (React.createElement("div", { className: "fe-wrapper page-wrapper fe-mangamnet-wrapper" },
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "New Dashboard"))),
        React.createElement("div", { className: "orderlist-main-wrapper" },
            React.createElement("div", { className: "filter-menu-wrapper border-bottom mobile-view-filters" },
                React.createElement("div", { className: "search-filter" }),
                React.createElement("div", { className: "filter-options auto-route mobile-view-filters" },
                    React.createElement(multi_selector_1.default, { label: "Lab Code", dropDownList: (0, array_helpers_1.convertLabcodeResponse)(labList).sort(function (a, b) {
                            return a.label.localeCompare(b.label);
                        }), onChangeHnadlre: function (value) { return setSelectedLab(value); }, value: selectedLab }),
                    React.createElement(drop_down_component_1.default, { dropDownList: (companiesList === null || companiesList === void 0 ? void 0 : companiesList.length) > 0 ? companiesList : [], onChange: function (val) { return setCompany(val); }, value: company, placeholder: 'Data Area ID', disableClearable: true }),
                    React.createElement(drop_down_component_1.default, { dropDownList: (vendorList === null || vendorList === void 0 ? void 0 : vendorList.length) > 0 ? vendorList : [], onChange: function (val) { return setSelectedVendor(val); }, value: selectedVendor, placeholder: 'Select Vendor', disableClearable: true, width: '145px' }),
                    React.createElement(drop_down_component_1.default, { name: "zonalManager", placeholder: "Zonal Manager", dropDownList: zonal_managers.length > 0 ? zonal_managers : [], onChange: function (val) {
                            setZonalManager(val);
                        }, disableClearable: true, value: zonalManager, width: '145px' }),
                    React.createElement(drop_down_component_1.default, { name: "regionalManager", placeholder: "Regional Manager", dropDownList: regional_managers.length > 0 ? regional_managers : [], onChange: function (val) {
                            setRegionalManager(val);
                        }, disableClearable: true, value: regionalManager, width: '145px' }),
                    React.createElement(multi_selector_1.default, { label: "Select State", dropDownList: stateList && stateList.sort(function (a, b) { return a.label.localeCompare(b.label); }), onChangeHnadlre: callbackUpdateSelectedStates, value: filterSelectedStates }),
                    React.createElement(multi_selector_1.default, { noOptions: 'No cities found', hasSelectAll: false, label: "Select City", dropDownList: citiesData && citiesData.sort(function (a, b) { return a.label.localeCompare(b.label); }), onChangeHnadlre: callbackUpdateSelectedCities, value: filterSelectedCities || [] }),
                    React.createElement(text_filed_with_fromto_Daterange_1.default, { presentDate: true, isDateRangeSelcted: ((_c = auto_routing_filtes === null || auto_routing_filtes === void 0 ? void 0 : auto_routing_filtes.date_range) === null || _c === void 0 ? void 0 : _c.start_date) &&
                            ((_d = auto_routing_filtes === null || auto_routing_filtes === void 0 ? void 0 : auto_routing_filtes.date_range) === null || _d === void 0 ? void 0 : _d.end_date)
                            ? true
                            : false, startDate: (_e = auto_routing_filtes === null || auto_routing_filtes === void 0 ? void 0 : auto_routing_filtes.date_range) === null || _e === void 0 ? void 0 : _e.start_date, endDate: (_f = auto_routing_filtes === null || auto_routing_filtes === void 0 ? void 0 : auto_routing_filtes.date_range) === null || _f === void 0 ? void 0 : _f.end_date, onChangeHandler: callBackOnDateRangeSelect }),
                    React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: filterHandler }))),
            React.createElement("div", { className: "long-page-scroll" },
                React.createElement("div", { className: "routingc-card-nav" },
                    React.createElement("div", { className: "new-dashboard-wrapper" },
                        React.createElement(material_1.Grid, { container: true, columns: { xs: 12, lg: 12, xl: 12 }, columnSpacing: 3 },
                            React.createElement(material_1.Grid, { item: true, lg: 12, xs: 12, xl: 12, className: "cards-grids-item" },
                                React.createElement("h2", { className: "heading cards-heaidng" },
                                    ' ',
                                    "FE Activity & Performance Monitor",
                                    ' '),
                                React.createElement("div", { className: "orderlist-main" },
                                    React.createElement(material_1.Card, { className: "route-card card-main bg-lightblue disabled" },
                                        React.createElement(material_1.CardContent, { className: "dashboard-card-content " },
                                            React.createElement("div", { className: "top-block" },
                                                React.createElement(material_1.Typography, { gutterBottom: true, className: "title" }, (dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.total_fe_users_count) || 0)),
                                            React.createElement(material_1.Typography, { className: "content" }, auto_routing_helper_1.NEW_DASHBOARD_LABELS.totalActiveFECount))),
                                    React.createElement(material_1.Card, { className: "route-card card-main bg-lightblue disabled" },
                                        React.createElement(material_1.CardContent, { className: "dashboard-card-content" },
                                            React.createElement("div", { className: "top-block" },
                                                React.createElement(material_1.Typography, { gutterBottom: true, className: "title" }, "".concat((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.logged_fe_users_count) || 0, " (").concat(Math.round(Number(dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.logged_fe_users_percentage) || 0), "%)"))),
                                            React.createElement(material_1.Typography, { className: "content" }, auto_routing_helper_1.NEW_DASHBOARD_LABELS.loggedInFE))),
                                    React.createElement(material_1.Card, { className: "route-card card-main bg-lightblue disabled" },
                                        React.createElement(material_1.CardContent, { className: "dashboard-card-content" },
                                            React.createElement("div", { className: "top-block" },
                                                React.createElement(material_1.Typography, { gutterBottom: true, className: "title" }, "".concat((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.first_collection_on_time_completed_count) || 0, " (").concat(Math.round(Number(dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.first_collection_on_time_completed_percentage) || 0), "%)"))),
                                            React.createElement(material_1.Typography, { className: "content" }, auto_routing_helper_1.NEW_DASHBOARD_LABELS.completedFirstCollectionOntime))),
                                    React.createElement(material_1.Card, { className: "route-card card-main bg-lightblue ".concat((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.first_collection_delayed_completed_count) <= 0
                                            ? 'disabled'
                                            : classN === 1
                                                ? 'active-card'
                                                : ''), onClick: function () {
                                            if ((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.first_collection_delayed_completed_count) > 0) {
                                                setOpen(true);
                                                setClassN(1);
                                                setFeDashboardFilter(1);
                                            }
                                        } },
                                        React.createElement(material_1.CardContent, { className: "dashboard-card-content" },
                                            React.createElement("div", { className: "top-block" },
                                                React.createElement(material_1.Typography, { gutterBottom: true, className: "title" }, "".concat((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.first_collection_delayed_completed_count) || 0, " (").concat(Math.round(Number(dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.first_collection_delayed_completed_percentage) || 0), "%)"))),
                                            React.createElement(material_1.Typography, { className: "content" }, auto_routing_helper_1.NEW_DASHBOARD_LABELS.delyedFirstCollectionOntime))),
                                    React.createElement(material_1.Card, { className: "route-card card-main bg-lightblue ".concat((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.not_logged_fe_users_count) <= 0
                                            ? 'disabled'
                                            : classN === 2
                                                ? 'active-card'
                                                : ''), onClick: function () {
                                            if ((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.not_logged_fe_users_count) > 0) {
                                                setOpen(true);
                                                setClassN(2);
                                                setFeDashboardFilter(2);
                                            }
                                        } },
                                        React.createElement(material_1.CardContent, { className: "dashboard-card-content" },
                                            React.createElement("div", { className: "top-block" },
                                                React.createElement(material_1.Typography, { gutterBottom: true, className: "title" }, "".concat((dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.not_logged_fe_users_count) || 0, " (").concat(Math.round(Number(dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.not_logged_fe_users_percentage) || 0), "%)"))),
                                            React.createElement(material_1.Typography, { className: "content" }, auto_routing_helper_1.NEW_DASHBOARD_LABELS.notLoggedFE)))))))))),
        React.createElement(material_1.Drawer, { variant: "temporary", anchor: "bottom", open: open, className: classes.customDrawer, onClose: handleDrawerClose, disableEnforceFocus: true, disableAutoFocus: true, ModalProps: {
                keepMounted: false,
            } },
            React.createElement("div", { onClick: handleDrawerClose, className: "drawer-close-btn" },
                React.createElement("span", { className: "icon-close" })),
            React.createElement(fe_dashboard_list_1.default, { feDashboardFilter: feDashboardFilter, payload: payload })),
        React.createElement(pop_up_1.default, { open: navigationPopup },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h2", { className: "heading" }, "Request Submitted"),
                React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
            React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setNavigationPopup(false); } }),
                React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))));
};
exports.default = NewDashboard;
